
import $ from 'jquery';
import 'bootstrap';

$(() => {
  // See this for the general idea:
  // https://coderwall.com/p/6qaeya/lazy-carousel-in-bootstrap
  const carousels: any = $('.carousel.hi-lazy');

  carousels.carousel({ interval: false })
  carousels.on('slide.bs.carousel', (event) => {
    const lazy = $(event.relatedTarget).find('img[data-slide-src]')
    
    console.log(lazy, lazy.data('slide-src'), lazy.data('slide-srcset'));
    if (lazy.data('slide-src')) {
      lazy.attr('src', lazy.data('slide-src'))
    }

    if (lazy.data('slide-srcset')) {
      lazy.attr('srcset', lazy.data('slide-srcset'))
    }
  });
});


// This is from
// https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video/
export default document.addEventListener('DOMContentLoaded', () => {
  // console.log(carousels);

  let lazyImages: HTMLImageElement[] = [].slice.call(
    document.querySelectorAll('img[data-src], img[data-srcset]')
  );

  if ('IntersectionObserver' in window) {
    let lazyImageObserver = new IntersectionObserver((entries, observer) => {
      // console.log(entries);
      entries.forEach((entry) => {
        let lazyImage = entry.target as HTMLImageElement;
        
        if (entry.isIntersecting) {
          // console.log('Now visible, loading:', lazyImage);
          if (lazyImage.dataset.src) {
            lazyImage.src = lazyImage.dataset.src;
          }
  
          if (lazyImage.dataset.srcset) {
            lazyImage.srcset = lazyImage.dataset.srcset;
          }
          
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach((lazyImage) => {
      lazyImageObserver.observe(lazyImage);
    });
  }
});
